import { cx } from "@light-technology/components";

// Outer span: h-lh matches the full line box height of the parent's typography.
// Inner span: h-[1em] = font-size, so the visible bar is only as tall as the
// text glyphs, leaving the leading gap transparent above and below.
export const SkeletonLine = ({
  className,
  subtle = false,
}: {
  className?: string;
  subtle?: boolean;
}) => (
  <span className={cx("flex h-lh items-center", className)} role="status">
    <span
      className={cx(
        "h-[1em] w-full animate-pulse rounded-full",
        subtle ? "bg-fg-disabled_subtle" : "bg-fg-disabled",
      )}
    />
  </span>
);
